import {
  Accordion as MaterialAccordion,
  AccordionDetails as MaterialAccordionDetails,
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummary as MaterialAccordionSummary,
  AccordionSummaryProps,
} from '@mui/material';
import React from 'react';

export const Accordion: React.FC<AccordionProps> = MaterialAccordion;
export const AccordionDetails: React.FC<AccordionDetailsProps> = MaterialAccordionDetails;
export const AccordionSummary: React.FC<AccordionSummaryProps> = MaterialAccordionSummary;
